import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, SelectField, TextField } from 'bonfire-kindling';

const countryOptions = ['US', 'Canada'];
const CountrySelect = ({ onChange, value, name }) => {
  const { t } = useTranslation();
  const valueInOptions = countryOptions.includes(value);
  const [selectValue, setSelectValue] = useState(value && (valueInOptions ? value : 'other'));
  useEffect(() => {
    if (countryOptions.includes(selectValue)) {
      onChange({ target: { value: selectValue, name } });
    }
    if (selectValue === 'other' && valueInOptions) {
      onChange({ target: { value: '', name } });
    }
  }, [selectValue, onChange, name, valueInOptions]);
  return (
    <>
      <SelectField
        value={selectValue}
        onChange={e => setSelectValue(e.target.value)}
        label={t('settings.business.country')}
        margin="dense"
        fullWidth
      >
        <MenuItem value="Canada" label="Canada" />
        <MenuItem value="US" label="US" />
        <MenuItem value="other" label={t('settings.business.options.other')} />
      </SelectField>
      <TextField
        label={t('settings.business.specific_country')}
        margin="dense"
        fullWidth
        disabled={selectValue !== 'other'}
        value={valueInOptions ? '' : value}
        onChange={e => onChange({ ...e, target: { ...e.target, name } })}
      />
      <TextField sx={{ display: 'none' }} name={name} value={value}></TextField>
    </>
  );
};

export default CountrySelect;
